/**
 * @module framework/directives/sanitize-Href
 */

import { Directive, DirectiveBinding } from 'vue';

import { App } from '~/framework/vue';

export const sanitizeHrefDirective: Directive<HTMLElement> = {
    beforeMount(el, binding) {
        applySanitization(el, binding);
    },
    updated(el, binding) {
        applySanitization(el, binding);
    }
}

// Register a global custom directive called `v-sanitize-href`
export const sanitizeHref = (app: App) => {
    app.directive('sanitize-href', sanitizeHrefDirective);
};

function applySanitization(el: HTMLElement, binding: DirectiveBinding<string>) {
    const sanitizedUrl = sanitizeUrl(binding.value);
    el.setAttribute('href', sanitizedUrl);
}

function sanitizeUrl(url: string): string {
    // Page anchor
    if (!url) return "#"
    if (url.startsWith("#")) return url;

    const isExternalUrl = new RegExp('^(?:[a-z\+]+:)?\/\/', 'i').exec(url) // eslint-disable-line
    if (isExternalUrl) {
        const allowedProtocols = ['http:', 'https:', 'mailto:','tel:', 'ftp:', 'file:']
        return allowedProtocols.some(protocol => url.toLowerCase().startsWith(protocol)) ? url : "#"
    } else {
        // internal url
        return url
    }
}
